import * as XLSX from 'xlsx';

// Annual Feedback Form Template Data
export const generateAnnualFeedbackTemplate = () => {
  const templateData = [
    ['Title', 'Type', 'Required', 'Section', 'Rating Scale', 'Choices'],
    
    // Employee Information Section (at the top)
    ['Name', 'text', 'Yes', 'Employee Information', '', ''],
    ['Employee ID', 'text', 'Yes', 'Employee Information', '', ''],
    ['Department', 'text', 'Yes', 'Employee Information', '', ''],
    ['Designation', 'text', 'Yes', 'Employee Information', '', ''],
    ['Work Location', 'text', 'Yes', 'Employee Information', '', ''],
    ['Length of Service', 'text', 'Yes', 'Employee Information', '', ''],
    
    // Work Environment & Culture Section
    ['Do you feel comfortable sharing your opinions and ideas openly?', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['Do you feel respected and valued by your colleagues?', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['Do you feel respected and valued at work for your contribution?', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['The company fosters an inclusive and supportive work culture', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['The work culture promotes collaboration and learning', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['My team works well together and supports each other', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['Cross-department collaboration is encouraged and effective', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['The company values diversity and treats everyone fairly', 'rating', 'Yes', 'Work Environment & Culture', 'frequency', ''],
    ['How satisfied are you with the overall work culture in our company?', 'rating', 'Yes', 'Work Environment & Culture', 'satisfaction', ''],
    ['How would you describe the work environment in few words?', 'comment', 'No', 'Work Environment & Culture', '', ''],
    
    // Career Development & Growth Section
    ['I have the tools and resources to perform my job effectively', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    ['I have sufficient opportunities to learn and grow here', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    ['My work gives me a sense of purpose', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    ['My contributions are recognized and appreciated', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    ['I feel safe and comfortable in my workplace', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    ['My workload is reasonable and manageable', 'rating', 'Yes', 'Career Development & Growth', 'likert', ''],
    
    // Teamwork & Collaboration Section
    ['My team members are cooperative and supportive', 'rating', 'Yes', 'Teamwork & Collaboration', 'likert', ''],
    ['I feel recognized for the work I do', 'rating', 'Yes', 'Teamwork & Collaboration', 'likert', ''],
    ['I feel respected and valued as a team member', 'rating', 'Yes', 'Teamwork & Collaboration', 'likert', ''],
    ['I feel motivated to give my best at work', 'rating', 'Yes', 'Teamwork & Collaboration', 'likert', ''],
    
    // Compensation & Benefits Section
    ['I feel satisfied with my role & responsibilities at work', 'rating', 'Yes', 'Compensation & Benefits', 'satisfaction', ''],
    ['I am satisfied with my salary compared to my responsibilities', 'rating', 'Yes', 'Compensation & Benefits', 'satisfaction', ''],
    ['I am satisfied with the benefits offered (leave, insurance, flexibility, etc.)', 'rating', 'Yes', 'Compensation & Benefits', 'satisfaction', ''],
    ['How would you rate the work-life balance here?', 'rating', 'Yes', 'Compensation & Benefits', 'satisfaction', ''],
    ['What additional comment would you like to share with company?', 'comment', 'No', 'Compensation & Benefits', '', ''],
    
    // Feedback on Manager & Leadership Section
    ['My manager provides the guidance and support I need', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    ['My manager is approachable and supportive', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    ['Management communicates company updates clearly and transparently', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    ['Management is fair in their decisions and treats employees well', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    ['Leadership is approachable and open to employee feedback', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    ['I feel Management takes employee feedback seriously and acts on it', 'rating', 'Yes', 'Feedback on Manager & Leadership', 'likert', ''],
    
    // HR Feedback Section
    ['The recruitment and onboarding process was smooth when I joined the company', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['The onboarding process helped me settle into my role effectively', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['HR policies are clear and fairly explained and implemented', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['I feel comfortable approaching HR with sensitive issues', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['HR is approachable and responsive to my concerns', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['My concerns and queries are addressed in a timely manner', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['HR organizes engagement activities that improve workplace morale', 'rating', 'Yes', 'HR Feedback', 'likert', ''],
    ['Are you satisfied with the current HR policies and benefits (leave, flexibility, etc.)?', 'rating', 'Yes', 'HR Feedback', 'satisfaction', ''],
    
    // IT Feedback Section
    ['I received the necessary company assets at the time of my joining (laptop/desktop, Mouse, charger, other accessories)', 'radio', 'Yes', 'IT Feedback', '', 'Agree,Disagree'],
    ['My laptop/desktop functions well', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['My laptop/desktop repair needs were promptly identified', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['The cost incurred on laptop repairs were reimbursed on time', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['The internet connectivity provided by the company is effective', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['The IT support responds promptly when I face any technical issues', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['I feel satisfied with the overall IT support provided by the company', 'rating', 'Yes', 'IT Feedback', 'likert', ''],
    ['What additional comments or suggestions would you like to share about IT support and Infrastructure?', 'comment', 'No', 'IT Feedback', '', ''],
    
    // Accounts and Finance Feedback Section
    ['My salary is credited on time every month', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['Reimbursements and dues are cleared on time', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['Vendor Payments are processed on time by Accounts Team', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['I feel comfortable approaching the Accounts team for clarifications', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['I feel satisfied with the suggestions/solutions given by the Accounts team', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['Financial Processes and Policies are clearly communicated by the Accounts Team', 'rating', 'Yes', 'Accounts and Finance Feedback', 'likert', ''],
    ['What additional suggestions would you like to share for improvements?', 'comment', 'No', 'Accounts and Finance Feedback', '', ''],
    
    // Performance Management & Appraisal Process Feedback Section
    ['There is a clear communication of my goals and expectations by my manager', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['I am satisfied with the criteria of evaluation of my performance', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['I receive constructive and regular feedback on my performance', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['Performance reviews are conducted fairly and transparently', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['The appraisal process recognizes and rewards my contributions effectively', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['I receive adequate opportunities for skill development and career growth through performance management', 'rating', 'Yes', 'Performance Management & Appraisal Process Feedback', 'likert', ''],
    ['What improvements would you suggest in the performance management and appraisal process?', 'comment', 'No', 'Performance Management & Appraisal Process Feedback', '', ''],
    
    // Admin Feedback Section
    ['The cleanliness of the office premises is well looked after', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['The office supplies and stationery are available when required', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['Adequate and timely celebration arrangements are made', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['The seating arrangements and workspace are well maintained and looked after', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['Workplace safety and security arrangements are adequate', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['The admin team responds promptly to requests and concerns', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['I am satisfied with the overall support provided by the admin team', 'rating', 'Yes', 'Admin Feedback', 'likert', ''],
    ['What improvements would you suggest in the admin support?', 'comment', 'No', 'Admin Feedback', '', '']
  ];

  return templateData;
};

// Function to download the annual feedback template
export const downloadAnnualFeedbackTemplate = () => {
  const templateData = generateAnnualFeedbackTemplate();
  
  // Create the main questions sheet
  const ws = XLSX.utils.aoa_to_sheet(templateData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Annual Feedback Form');
  
  // Create instructions sheet
  const instructionsData = [
    ['INSTRUCTIONS FOR ANNUAL FEEDBACK FORM'],
    [''],
    ['This Excel file contains the complete annual feedback form template.'],
    [''],
    ['RATING SCALE OPTIONS:'],
    ['likert', 'Strongly Disagree | Disagree | Neutral | Agree | Strongly Agree'],
    ['satisfaction', 'Very Dissatisfied | Dissatisfied | Neutral | Satisfied | Very Satisfied'],
    ['frequency', 'Never | Rarely | Sometimes | Often | Always'],
    [''],
    ['QUESTION TYPES:'],
    ['text', 'Single line text input'],
    ['comment', 'Multi-line text input'],
    ['radio', 'Single choice from options'],
    ['checkbox', 'Multiple choice from options'],
    ['rating', 'Rating scale (use Rating Scale column)'],
    ['boolean', 'Yes/No question'],
    [''],
    ['VALIDATION RULES:'],
    ['Title', 'Required column - cannot be empty'],
    ['Type', 'Must be one of: text, comment, radio, checkbox, rating, boolean'],
    ['Required', 'Must be: Yes/No, True/False, Y/N, 1/0'],
    ['Section', 'Optional - for grouping questions'],
    ['Rating Scale', 'For rating questions: likert, satisfaction, frequency'],
    ['Choices', 'Required for radio/checkbox - comma separated values'],
    [''],
    ['USAGE:'],
    ['1. Download this template'],
    ['2. Modify questions as needed'],
    ['3. Import the Excel file into the survey builder'],
    ['4. Review and save the survey']
  ];
  
  const wsInstructions = XLSX.utils.aoa_to_sheet(instructionsData);
  XLSX.utils.book_append_sheet(wb, wsInstructions, 'Instructions');
  
  // Auto-size columns for main sheet
  const colWidths = [
    { wch: 60 }, // Title
    { wch: 15 }, // Type
    { wch: 10 }, // Required
    { wch: 35 }, // Section
    { wch: 15 }, // Rating Scale
    { wch: 50 }  // Choices
  ];
  ws['!cols'] = colWidths;

  XLSX.writeFile(wb, 'annual_feedback_form_template.xlsx');
};

// Function to parse annual feedback Excel data
export const parseAnnualFeedbackExcel = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length < 2) {
          reject('Excel file must have at least 2 rows (header + data)');
          return;
        }

        const headers = jsonData[0];
        const rows = jsonData.slice(1);

        // Find column indices
        const titleIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('title') || 
          h && h.toString().toLowerCase().includes('question'));
        const typeIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('type'));
        const requiredIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('required'));
        const sectionIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('section'));
        const ratingScaleIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('rating') && 
          h.toString().toLowerCase().includes('scale'));
        const choicesIndex = headers.findIndex(h => 
          h && h.toString().toLowerCase().includes('choice'));

        if (titleIndex === -1 || typeIndex === -1 || requiredIndex === -1) {
          reject('Missing required columns: Title/Question, Type, Required');
          return;
        }

        const questions = [];
        let questionCounter = 1;

        rows.forEach((row, rowIndex) => {
          // Skip instruction rows and empty rows
          const title = row[titleIndex] ? row[titleIndex].toString().trim() : '';
          const type = row[typeIndex] ? row[typeIndex].toString().toLowerCase().trim() : '';
          
          // Skip rows that are instructions or don't have valid question data
          if (!title || 
              title.toLowerCase().includes('instructions') ||
              title.toLowerCase().includes('rating scale options') ||
              title.toLowerCase().includes('question types') ||
              title.toLowerCase().includes('validation rules') ||
              title.toLowerCase().includes('example') ||
              title.toLowerCase().includes('notes') ||
              type.includes('|') || // Skip rows with pipe-separated values (like rating scale descriptions)
              type.includes('input') || // Skip instruction rows
              type.includes('choice') || // Skip instruction rows
              type.includes('scale') || // Skip instruction rows
              type.includes('question')) { // Skip instruction rows
            return;
          }

          // Only process rows that have a valid question type
          const validTypes = ['text', 'comment', 'radio', 'checkbox', 'rating', 'boolean'];
          if (!validTypes.includes(type)) {
            return; // Skip this row
          }

          const question = {
            name: `question${questionCounter}`,
            title: title,
            type: type,
            isRequired: row[requiredIndex] ? ['yes', 'true', '1', 'y'].includes(row[requiredIndex].toString().toLowerCase().trim()) : false,
            section: row[sectionIndex] ? row[sectionIndex].toString().trim() : '',
            choices: [],
            ratingScale: 'likert'
          };

          // Handle rating scale
          if (question.type === 'rating' && row[ratingScaleIndex]) {
            const scaleValue = row[ratingScaleIndex].toString().toLowerCase().trim();
            if (['likert', 'satisfaction', 'frequency', 'agreement'].includes(scaleValue)) {
              question.ratingScale = scaleValue;
              // Set choices based on rating scale
              const ratingScales = {
                likert: [
                  { value: 1, text: 'Strongly Disagree' },
                  { value: 2, text: 'Disagree' },
                  { value: 3, text: 'Neutral' },
                  { value: 4, text: 'Agree' },
                  { value: 5, text: 'Strongly Agree' }
                ],
                satisfaction: [
                  { value: 1, text: 'Very Dissatisfied' },
                  { value: 2, text: 'Dissatisfied' },
                  { value: 3, text: 'Neutral' },
                  { value: 4, text: 'Satisfied' },
                  { value: 5, text: 'Very Satisfied' }
                ],
                frequency: [
                  { value: 1, text: 'Never' },
                  { value: 2, text: 'Rarely' },
                  { value: 3, text: 'Sometimes' },
                  { value: 4, text: 'Often' },
                  { value: 5, text: 'Always' }
                ]
              };
              question.choices = ratingScales[scaleValue] || ratingScales.likert;
            }
          }

          // Handle choices for radio/checkbox questions
          if ((question.type === 'radio' || question.type === 'checkbox') && row[choicesIndex]) {
            const choicesString = row[choicesIndex].toString();
            const choicesArray = choicesString.split(',').map(c => c.trim()).filter(c => c);
            question.choices = choicesArray.map((choice, index) => ({ 
              value: choice, 
              text: choice 
            }));
          }

          questions.push(question);
          questionCounter++;
        });

        resolve(questions);
      } catch (error) {
        reject('Error reading Excel file: ' + error.message);
      }
    };

    reader.onerror = () => reject('Error reading file');
    reader.readAsArrayBuffer(file);
  });
};
